import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import Utils from 'front/utils/Utils.js'
import BaseView from 'front/components/BaseView/BaseView.js'

import './Video.css'
import template from './Video.jinja'


var Video = BaseView.extend({
    initialize () {
        _.bindAll(this, '_visibilityHandler', 'activateVideo', 'activateImage', 'playInImage', 'playOutImage', 'playInVideo', 'playOutVideo')

        this.state = {}

        if (app.settings.isTablet) {
            this.playIn = this.playInImage
            this.playOut = this.playOutImage
            this.activate = this.activateImage

            this.$img = this.$('.Video-img')
        } else {
            this.playIn = this.playInVideo
            this.playOut = this.playOutVideo
            this.activate = this.activateVideo

            this.$video = this.$('video')
            this.video = this.$video[0]

            this.state.playing = false;

            // TODO: Останавливать видео, если его не видно во вьюпорте
            this.visibilityHandler = _.throttle(this._visibilityHandler, 500)

            app.els.$window.on('scroll', this.visibilityHandler)

            this.$video.on('canplaythrough', this.startVideo)
        }
    },

    _visibilityHandler () {
        if (this.elementInViewport(this.$video)) {
            if (!this.state.playing) {
                this.video.play();
                this.state.playing = true;
            }
        } else {
            if (this.state.playing) {
                this.video.pause();
                this.state.playing = false;
            }
        }
    },

    elementInViewport(el) {
        if (typeof jQuery === "function" && el instanceof jQuery) {
            el = el[0];
        }

        var rect = el.getBoundingClientRect();

        return rect.bottom > 0 &&
            rect.right > 0 &&
            rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
            rect.top < (window.innerHeight || document.documentElement.clientHeight);
    },

    playInVideo(options) {
        this.video.currentTime = 0
        this.video.play()

        $(window).on('resize scroll', this.visibilityHandler)

        return $.Velocity.animate(this.$el[0], {opacity: 1}, _.extend({
            duration: 1500
        }, options))
    },

    playOutVideo(options) {
        $(window).off('resize scroll', this.visibilityHandler)

        return $.Velocity.animate(this.$el[0], {opacity: 0}, _.extend({
            duration: 1500
        }, options))
    },

    playInImage(options) {
        return $.Velocity.animate(this.$el[0], {opacity: 1}, _.extend({
            duration: 1500
        }, options))
    },

    playOutImage(options) {
        return $.Velocity.animate(this.$el[0], {opacity: 0}, _.extend({
            duration: 1500
        }, options))
    },

    activateImage() {
        return new Promise(
            (resolve, reject) => {
                resolve()
            }
        )
    },

    activateVideo() {
        return new Promise(
            (resolve, reject) => {
                this.$video.on('canplaythrough', () => {
                    this.$video.off('canplaythrough')

                    resolve()
                })

                if (this.video.readyState > 3) {
                    this.$video.off('canplaythrough')

                    resolve()
                }
            }
        )
    }
})

export default Video


// WEBPACK FOOTER //
// ./assets/app/front/components/Video/Video.js